export const ClientId = {
  espro: 'espro',
  etyflex: 'etyflex',
  siap: 'siap',
  sanok: 'sanok',
  ekoplast: 'ekoplast',
  defaultClient: 'generic',
  nanochem: 'nanochem',
} as const;

export type ClientId = (typeof ClientId)[keyof typeof ClientId];
